import { corpApi } from './api/corpApi';
import { niceApi } from './api/niceApi';
import { executeApi } from './common/executeApi';
class CorpService {
  constructor({ corpApiInstance = corpApi, niceApiInstance = niceApi } = {}) {
    this.corpApi = corpApiInstance;
    this.niceApi = niceApiInstance;
  }

  /**
   * NICE 본인인증 정보를 조회합니다.
   * @returns {Promise<{
   *   sessionKey: string,
   *   authUrl: string
   * }>} 레디스 세션 키 및 NICE 인증 URL
   */
  async requestNiceAuthInfo() {
    return executeApi(() => this.niceApi.userCheckApi(), 'requestNiceAuthInfo');
  }
  /**
   * NICE 본인인증 완료 후 인증 결과를 검증하고 법인 전화번호를 변경합니다.
   *
   * @param {Object} params
   * @param {string} params.corpId 법인 아이디
   * @param {string} params.encryptString NICE 인증 완료 결과값
   * @param {string} params.sessionKey NICE 인증 요청 시 발급된 레디스 세션 키
   *
   * @returns {Promise<boolean>}
   * true: 전화번호 변경 성공
   */
  async verifyNiceAuth({ corpId, encryptString, sessionKey }) {
    return executeApi(() => this.corpApi.updateCorpApi(corpId, encryptString, sessionKey), 'verifyNiceAuth');
  }

  /**
   * 회원가입
   *
   * @param {Object} params
   * @param {string} params.email 이메일
   * @param {string} params.password 비밀번호
   * @param {string} params.corpNm 법인명
   * @param {'Y'|'N'} params.marketing 마케팅 수신 여부
   * @param {string} params.encryptString NICE 인증 결과값
   * @param {string} params.sessionKey NICE 인증 요청 시 발급된 레디스 세션 키
   *
   * @returns {Promise<number>} 회원가입 결과 값
   */
  async signUp({ email, password, corpNm, marketing, encryptString, sessionKey }) {
    return executeApi(() => this.corpApi.signUpApi(email, password, corpNm, marketing, encryptString, sessionKey), 'signUp');
  }
  /**
   * 이메일 전송
   * @param {string} toMail
   */
  async requestMail(toMail) {
    try {
      await this.corpApi.getAuthEmail(toMail);
    } catch (error) {
      console.error(`requestMail error : ${error}`);
      throw error;
    }
  }
}

export const corpService = new CorpService();
